import React from 'react';

const WrenchEmoji = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9655 17.819C24.4107 17.819 23.8728 17.8886 23.3546 18.009L14.103 8.75741C14.2225 8.23918 14.2921 7.70131 14.2921 7.14651C14.2921 3.19952 11.0926 0 7.14651 0C6.34194 0 5.27157 0.817049 6.16266 1.70813L8.83591 4.38138C8.83591 4.38138 9.72699 6.16355 7.94482 7.94482C6.16266 9.7261 4.38049 8.83502 4.38049 8.83502L1.70813 6.16266C0.817049 5.27157 0 6.33748 0 7.14651C0 11.0935 3.19952 14.293 7.14651 14.293C7.70131 14.293 8.23918 14.2234 8.75741 14.1039L18.0081 23.3546C17.8877 23.8728 17.8181 24.4107 17.8181 24.9655C17.8181 28.9125 21.0185 32.1111 24.9646 32.1111C25.7683 32.1111 26.8386 31.2941 25.9476 30.403L23.2743 27.7297C23.2743 27.7297 22.3832 25.9476 24.1654 24.1663C25.9476 22.385 27.7288 23.2752 27.7288 23.2752L30.4021 25.9485C31.2941 26.8395 32.1111 25.7736 32.1111 24.9655C32.1111 21.0185 28.9116 17.819 24.9655 17.819Z"
        fill="#8899A6"
      />
    </svg>
  );
};

export default WrenchEmoji;
